module.exports = __webpack_public_path__ + "img/yqhy.b863dfe1.png";